module.exports = __webpack_public_path__ + "img/garage-overhang.8326f647.webp";